import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { ITab } from './ResourceDetailContainer';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

interface IProps<TAttributes> {
  currentTabId: string;
  tabs: ITab<TAttributes>[];
  onGenerateTab: (tab: ITab<TAttributes>) => JSX.Element | null;
  onTabChanged?: (tabId: string) => void;
}

export default function TabContainer<TAttributes>(props: IProps<TAttributes>) {
  const {
    tabs,
    currentTabId,
    onTabChanged,
    onGenerateTab,
  } = props;
  const visibleTabs = tabs.filter(t => !(t.hide && t.hide()));
  const [value, setValue] = React.useState(0);

  // prop change setState to rerender
  React.useEffect(() => {
    const tabIds = visibleTabs.map(t => t.id);
    const index = tabIds.indexOf(currentTabId);
    console.log('current tab', index);
    setValue(index);
  }, [currentTabId]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const newTab = visibleTabs[newValue];
    if (newTab && onTabChanged) {
      onTabChanged(newTab.id);
    }
    setValue(newValue);
  };

  const renderTabHeader = (tab: ITab<TAttributes>, index: number) => {
    const { title } = tab;
    return <Tab key={index} label={title} {...a11yProps(index)} />;
  };

  const renderTabPanel = (tab: ITab<TAttributes>, index: number) => {
    return (
      <TabPanel value={value} index={index} key={index}>
        {onGenerateTab(tab)}
      </TabPanel>
    );
  };

  return (
    <Box>
      <Tabs
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        {visibleTabs.map(renderTabHeader)}
      </Tabs>
      {visibleTabs.map(renderTabPanel)}
    </Box>
  );
}
